import React from 'react';
import { Card } from '@/components/ui/card';

export const gbp = (v) => `£${Number(v || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const monthLabel = (ym) => {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
};
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');

const TONES = { default: 'text-gray-900', good: 'text-emerald-700', warn: 'text-amber-700', bad: 'text-rose-700', info: 'text-sky-700' };

export function StatTile({ icon: Icon, label, value, sub, tone = 'default', testid }) {
  return (
    <Card className="p-4">
      <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-gray-500 mb-1">{Icon && <Icon className="w-3.5 h-3.5" />}{label}</div>
      <div className={`text-2xl font-bold ${TONES[tone] || TONES.default}`} data-testid={testid}>{value}</div>
      {sub && <div className="text-[11px] text-gray-500 mt-1">{sub}</div>}
    </Card>
  );
}

export function ProfitPill({ value, testid }) {
  const v = Number(value || 0);
  return (
    <span className={`tabular-nums font-bold ${v >= 0 ? 'text-emerald-700' : 'text-rose-700'}`} data-testid={testid}>
      {v < 0 ? '−' : ''}{gbp(Math.abs(v))}
    </span>
  );
}

export function ContactLinks({ row }) {
  return (
    <span className="inline-flex gap-2 text-[11px]">
      {row.phone && <a href={`sms:${row.phone}`} className="text-violet-700 hover:underline" data-testid={`contact-sms-${row.registration_id}`}>Text</a>}
      {row.email && <a href={`mailto:${row.email}`} className="text-sky-700 hover:underline" data-testid={`contact-email-${row.registration_id}`}>Email</a>}
    </span>
  );
}
